import {Col, Row} from 'react-bootstrap'
import ExistingCustomerInfo from './ExistingCustomerInfo'
import React, {useEffect, useState} from 'react'
import {defaultAgentEnrollment} from '../InterfaceAgentModal'

type accountInfoProps = {
  mode: any
  isExistingCustomer: boolean
  setIsExistingCustomer: (checked: boolean) => void
  formik: any
  isCommercialCustomer: any
  hasFieldError: any
  getCustomerByPhoneNumber: any
  setSearchText: any
  customerData: any
  customer: any
  searchText: any
  setIsCommercialCustomer: any
  setIsServiceSameAsBill: any
  primaryPhoneNumberValidation: any
  sendBillImageSMS: any
  featureFlags: any
  isOptedIn: boolean
  setIsOptedIn: any
  sendBillImageEmail: any
  documentRef: any
  documentDelivery: any
  checkPhonenumberOptin: any
  triggerOptinAlert: () => void
  disableExistingCustomerEnrollment: boolean
  checkPhoneLineType: any
  setSendContract: any
  emailAlreadyExists: any
  isSolarProduct: any
}

const AccountInfo = ({
  isSolarProduct,
  mode,
  emailAlreadyExists,
  isExistingCustomer,
  setIsExistingCustomer,
  formik,
  searchText,
  setSearchText,
  isCommercialCustomer,
  hasFieldError,
  getCustomerByPhoneNumber,
  customerData,
  customer,
  setIsCommercialCustomer,
  setIsServiceSameAsBill,
  primaryPhoneNumberValidation,
  sendBillImageSMS,
  featureFlags,
  isOptedIn,
  setIsOptedIn,
  sendBillImageEmail,
  documentRef,
  documentDelivery,
  checkPhonenumberOptin,
  triggerOptinAlert,
  disableExistingCustomerEnrollment,
  checkPhoneLineType,
  setSendContract,
}: accountInfoProps) => {
  const handlePrimaryOnBlur = (e: any) => {
    if (e.target.value.length === 10) {
      primaryPhoneNumberValidation(e.target.value)
    }
  }

  const handekEmailIdOnBlur = (e: any) => {
    if (e.target.value.length >= 10 && isSolarProduct) {
      emailAlreadyExists(e.target.value)
    }
  }
  const makeManualBlur = () => {
    phoneNumberRef?.current?.focus()
    phoneNumberRef?.current?.blur()
  }
  const phoneNumberRef = React.useRef() as React.MutableRefObject<HTMLInputElement>
  useEffect(() => {
    if (
      featureFlags?.getClientFeatureFlags?.enableLineTypeIntelligence &&
      !(formik.values.customerPrimaryPhoneNumber?.length < 10)
    ) {
      checkPhoneLineType({
        variables: {
          phoneNumber: formik.values.customerPrimaryPhoneNumber,
        },
      })
    }
  }, [formik.values.customerPrimaryPhoneNumber?.length])

  return (
    <div className={'current p-2'} data-kt-stepper-element='content'>
      <div className='w-100 h-425px'>
        {mode === 'create' && !disableExistingCustomerEnrollment && (
          <div className='form-check form-switch form-check-custom form-check-solid me-10'>
            <input
              className='form-check-input h-20px w-30px'
              type='checkbox'
              value=''
              checked={isExistingCustomer}
              id='flexSwitch20x30'
              onChange={(e) => {
                setIsExistingCustomer(e.target.checked)
                formik.setValues({...defaultAgentEnrollment})
              }}
            />
            <label className='form-check-label' htmlFor='flexSwitch20x30'>
              Enroll Existing Customer
            </label>
          </div>
        )}
        <div>
          {isExistingCustomer && mode === 'create' && !disableExistingCustomerEnrollment && (
            <ExistingCustomerInfo
              formik={formik}
              isCommercialCustomer={isCommercialCustomer}
              hasFieldError={hasFieldError}
              getCustomerByPhoneNumber={getCustomerByPhoneNumber}
              customerData={customerData}
              customer={customer}
              searchText={searchText}
              setSearchText={setSearchText}
              setIsCommercialCustomer={setIsCommercialCustomer}
              setIsServiceSameAsBill={setIsServiceSameAsBill}
              makeManualBlur={makeManualBlur}
            />
          )}
          <Row className='flex-column'>
            <Col lg='12' className='mb-4'>
              <Row className='align-items-center'>
                <Col lg='6'>
                  <label className='d-flex align-items-center mb-2 required'>
                    <span className='fs-6 fw-semibold lh-23px mt-2'>Primary Phone Number</span>
                  </label>
                  <div className='d-flex'>
                    <input
                      type='text'
                      value='+1'
                      className='form-control form-control-lg form-control-solid'
                      disabled
                      ref={phoneNumberRef}
                      style={{
                        width: '10%',
                        padding: '7px',
                        borderTopRightRadius: '0px',
                        borderBottomRightRadius: '0px',
                      }}
                    />
                    <input
                      type='text'
                      id='customerPrimaryPhoneNumber'
                      className='form-control form-control-lg form-control-solid mw-'
                      name='customerPrimaryPhoneNumber'
                      placeholder='Enter Primary number'
                      maxLength={10}
                      {...formik.getFieldProps('customerPrimaryPhoneNumber')}
                      onChange={(e) => {
                        if (e.target.value.length === 10) {
                          checkPhonenumberOptin({
                            variables: {
                              phoneNumber: e.target.value,
                            },
                          })
                        }
                        formik.setFieldValue('customerPrimaryPhoneNumber', e.target.value)
                        formik.setFieldValue('linetype', null)
                        formik.setFieldValue('contractbySms', false)
                        setSendContract(false)
                        handlePrimaryOnBlur(e)
                      }}
                      //onBlur={(e) => handlePrimaryOnBlur(e)}
                      style={{
                        width: '100%',
                        padding: '10px',
                        borderTopLeftRadius: '0px',
                        borderBottomLeftRadius: '0px',
                      }}
                    />
                  </div>
                  {featureFlags?.getClientFeatureFlags?.enableLineTypeIntelligence &&
                    formik.values.customerPrimaryPhoneNumber?.length >= 10 && (
                      <div className='' style={{width: '235px'}}>
                        <div
                          data-field='appname'
                          data-validator='notEmpty'
                          className='fv-help-block'
                        >
                          Phone line type :
                          {formik.values.linetype === null ? 'Not found' : formik.values.linetype}
                        </div>
                      </div>
                    )}
                  {formik.touched.customerPrimaryPhoneNumber &&
                    formik.errors.customerPrimaryPhoneNumber && (
                      <div className='text-danger position-absolute' style={{width: '235px'}}>
                        <div
                          data-field='appname'
                          data-validator='notEmpty'
                          className='fv-help-block'
                        >
                          {formik.errors.customerPrimaryPhoneNumber}
                        </div>
                      </div>
                    )}
                </Col>
                <Col lg='6' className='mt-7 d-flex'>
                  {featureFlags?.getClientFeatureFlags?.isBillImagesRequired && (
                    <div className='d-flex align-items-center'>
                      <button
                        className='btn btn-primary ms-2'
                        disabled={
                          !isOptedIn || formik.values.customerPrimaryPhoneNumber?.length < 10
                        }
                        onClick={() => sendBillImageSMS()}
                      >
                        Send SMS
                      </button>
                      {formik.values.customerPrimaryPhoneNumber.length === 10 && !isOptedIn && (
                        <i
                          className='bi bi-info-circle ms-2 text-primary cursor-pointer'
                          onClick={() => {
                            if (!isOptedIn) {
                              triggerOptinAlert()
                            }
                          }}
                        ></i>
                      )}
                    </div>
                  )}
                  {/* {featureFlags?.getClientFeatureFlags?.enableLineTypeIntelligence && ( <div className='d-flex align-items-center'>
                      <button
                        className='btn btn-primary ms-2'
                        disabled={
                          formik.values.customerPrimaryPhoneNumber?.length < 10 || isButtonClicked
                        }
                        onClick={() => {
                          checkPhoneLineType({
                            variables: {
                              phoneNumber: formik.values.customerPrimaryPhoneNumber,
                            },
                          });
                          setIsButtonClicked(true); 
                        }}
                      >
                        Check phone line type
                      </button>
                      
                    </div>)} */}
                </Col>
              </Row>
            </Col>

            <Col lg='6' className='mb-2'>
              <label className='d-flex align-items-center mb-2'>
                <span className='fs-6 fw-semibold lh-23px'>Mobile Number</span>
              </label>
              <div className='d-flex'>
                <input
                  id='customerPhoneNumber'
                  type='text'
                  value='+1'
                  className='form-control form-control-lg form-control-solid'
                  disabled
                  style={{
                    width: '10%',
                    padding: '7px',
                    borderTopRightRadius: '0px',
                    borderBottomRightRadius: '0px',
                  }}
                />
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  name='customerPhoneNumber'
                  placeholder='Enter Mobile number'
                  maxLength={10}
                  {...formik.getFieldProps('customerPhoneNumber')}
                  onChange={(e) => {
                    formik.setFieldValue('customerPhoneNumber', e.target.value)
                  }}
                  // onBlur={(e) => handleOnBlur(e)}
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderTopLeftRadius: '0px',
                    borderBottomLeftRadius: '0px',
                  }}
                />
              </div>
              {formik.touched.customerPhoneNumber && formik.errors.customerPhoneNumber && (
                <div className='text-danger'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {formik.errors.customerPhoneNumber}
                  </div>
                </div>
              )}
            </Col>
            <Col lg='12' className='mb-2'>
              <Row className='align-items-end'>
                <Col lg='6'>
                  <label
                    className={`d-flex align-items-center mb-2 ${
                      documentDelivery === 'EMAIL' ? 'required' : ''
                    }`}
                  >
                    <span className='fs-6 fw-semibold lh-23px'>Email ID</span>
                  </label>
                  <input
                    id='customerEmailId'
                    type='text'
                    ref={documentRef}
                    className='form-control form-control-lg form-control-solid'
                    name='customerEmailId'
                    placeholder='Enter email id'
                    maxLength={51}
                    {...formik.getFieldProps('customerEmailId')}
                    onChange={(e) => {
                      formik.setFieldValue('customerEmailId', e.target.value)
                      handekEmailIdOnBlur(e)
                    }}
                  />
                  {formik.errors.customerEmailId && hasFieldError && (
                    <div className='fv-plugins-message-container' style={{width: '235px'}}>
                      <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                        {formik.errors.customerEmailId}
                      </div>
                    </div>
                  )}
                </Col>
                <Col lg='6' className='mt-7'>
                  {featureFlags?.getClientFeatureFlags?.isBillImagesRequired &&
                    Boolean(formik.values.customerEmailId) && (
                      <button
                        className='btn btn-primary ms-2'
                        disabled={formik.errors.customerEmailId}
                        onClick={() => sendBillImageEmail()}
                      >
                        Send Email
                      </button>
                    )}
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}
export default AccountInfo